import { render, staticRenderFns } from "./GestioneCategorie.vue?vue&type=template&id=70f19658&"
import script from "./GestioneCategorie.vue?vue&type=script&lang=js&"
export * from "./GestioneCategorie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports